import { render, staticRenderFns } from "./contentview.vue?vue&type=template&id=5bdd1f44"
import script from "./contentview.vue?vue&type=script&lang=js"
export * from "./contentview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports